<template>
  <div>
    <v-chip v-bind="$attrs" v-if="value === 'to-do'" dark color="gray darken-1">{{ $t('statuses.todo') }}</v-chip>
    <v-chip v-bind="$attrs" v-if="value === 'preparation'" dark color="light-blue darken-1">{{ $t('statuses.preparation') }}</v-chip>
    <v-chip v-bind="$attrs" v-if="value === 'in Bearbeitung'" dark color="orange darken-1">{{ $t('statuses.process') }}</v-chip>
    <v-chip v-bind="$attrs" v-if="value === 'fertig'" dark color="green darken-1">{{ $t('statuses.done') }}</v-chip>
    <v-chip v-bind="$attrs" v-if="value === 'geblockt'" dark color="orange darken-1">{{ $t('statuses.blocked') }}</v-chip>
    <v-chip v-bind="$attrs" v-if="value === 'im Lager'" dark color="blue darken-1">{{ $t('statuses.in_stock') }}</v-chip>
  </div>
</template>

<script>

export default {
  name: 'BatchRunStatus',
  inheritAttrs: false,
  props: {
    value: {default: null},
  },

  components: {},

  computed: {
  },

  methods: {
  },

  async mounted() {
  },

  data() {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n src="@/components/PBatchRun/locales.json">
</i18n>
